import { TomanPrice } from '@/common/components/atom/toman/toman';
import { formatToman } from '../functions/coverage';
import type { Coverage } from '../types';

/** The doctor's own fee, struck through: the number only, light — the price that counts comes after it. */
export const StruckFee = ({ toman }: { toman: number }) => <s className="text-[13px] font-normal text-slate-400">{formatToman(toman)}</s>;

/** What the patient pays: «رایگان» in green, or the amount with the Toman sign. */
export const PayableNow = ({ coverage }: { coverage: Coverage }) =>
  coverage.payableToman === 0 ? (
    <span className="font-bold text-green-600">رایگان</span>
  ) : (
    <TomanPrice className="font-bold text-slate-900">{formatToman(coverage.payableToman)}</TomanPrice>
  );

/**
 * The card's «ویزیت آنلاین: …» line for a covered visit: the doctor's fee struck through next to what
 * the patient pays. Uncovered visits keep today's line.
 */
export const CorporateCardPrice = ({ coverage }: { coverage: Coverage }) => {
  if (coverage.status !== 'full' && coverage.status !== 'partial')
    return (
      <>
        ویزیت آنلاین: <TomanPrice>{formatToman(coverage.priceToman)}</TomanPrice>
      </>
    );
  return (
    <span className="inline-flex items-center gap-1.5">
      ویزیت آنلاین:
      <StruckFee toman={coverage.priceToman} />
      <PayableNow coverage={coverage} />
    </span>
  );
};
